var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7063 14.2919L9.41455 7.99981L7.9997 6.58496L1.70825 0.293176C1.31768 -0.0977252 0.683966 -0.0977255 0.293397 0.293176C0.0979462 0.488627 0.000222206 0.744782 0.00022316 1.0006C0.00022316 1.25642 0.0979481 1.51258 0.2934 1.70803L6.58518 7.99981L7.9997 9.41466L14.2915 15.7068C14.6821 16.0977 15.3158 16.0977 15.7063 15.7068C16.0972 15.3159 16.0972 14.6828 15.7063 14.2919Z",
    fill: "#677C95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.293331 14.292L6.58518 7.99981L7.9997 6.58496L14.2914 0.29322C14.682 -0.0976813 15.3157 -0.0976817 15.7063 0.29322C15.9017 0.488671 15.9994 0.744825 15.9994 1.00065C15.9994 1.25647 15.9017 1.51262 15.7063 1.70807L9.41455 7.99981L7.9997 9.41466L1.70818 15.7068C1.31761 16.0977 0.6839 16.0977 0.293331 15.7068C-0.0975704 15.3159 -0.0975704 14.6829 0.293331 14.292Z",
    fill: "#677C95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.496d00fbe53d9ba4c3191fea33c7de01.svg";
export { ForwardRef as ReactComponent };